class DonewellCaseSolutions {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-solutions-track]');
    this.previousButton = section.querySelector('[data-solutions-previous]');
    this.nextButton = section.querySelector('[data-solutions-next]');

    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.handlePrevious = this.handlePrevious.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.updateButtons = this.updateButtons.bind(this);

    this.previousButton.addEventListener('click', this.handlePrevious);
    this.nextButton.addEventListener('click', this.handleNext);
    this.track.addEventListener('scroll', this.updateButtons, { passive: true });
    window.addEventListener('resize', this.updateButtons);

    this.updateButtons();
  }

  getScrollDistance() {
    const card = this.track.querySelector('.dw-case-solutions__card');

    if (!card) {
      return this.track.clientWidth;
    }

    const styles = window.getComputedStyle(this.track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;

    return card.getBoundingClientRect().width + gap;
  }

  handlePrevious() {
    this.track.scrollBy({
      left: -this.getScrollDistance(),
      behavior: 'smooth'
    });
  }

  handleNext() {
    this.track.scrollBy({
      left: this.getScrollDistance(),
      behavior: 'smooth'
    });
  }

  updateButtons() {
    const maximumScroll = this.track.scrollWidth - this.track.clientWidth;
    const currentScroll = this.track.scrollLeft;

    this.previousButton.disabled = currentScroll <= 4;
    this.nextButton.disabled = currentScroll >= maximumScroll - 4;
  }

  destroy() {
    this.previousButton.removeEventListener('click', this.handlePrevious);
    this.nextButton.removeEventListener('click', this.handleNext);
    this.track.removeEventListener('scroll', this.updateButtons);
    window.removeEventListener('resize', this.updateButtons);
  }
}

const donewellSolutionsInstances = new Map();

function initializeDonewellSolutions(container = document) {
  const sections = container.querySelectorAll('[data-solutions-section]');

  sections.forEach((section) => {
    const sectionId = section.dataset.solutionsSection;

    if (donewellSolutionsInstances.has(sectionId)) return;

    donewellSolutionsInstances.set(
      sectionId,
      new DonewellCaseSolutions(section)
    );
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeDonewellSolutions();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeDonewellSolutions(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector('[data-solutions-section]');

  if (!section) return;

  const sectionId = section.dataset.solutionsSection;
  const instance = donewellSolutionsInstances.get(sectionId);

  if (instance) {
    instance.destroy();
    donewellSolutionsInstances.delete(sectionId);
  }
});